import { atom } from 'recoil';

const labelFilter = atom({
  key: 'labelFilter',
  default: false,
});

export default labelFilter;
